<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
            <userLeft :active="8" />
            <div class="box5">
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">我的资质</div>
                    <!-- <div class="box14" @click="showModal">+新增资质</div> -->
                </div>
                <div style="overflow: hidden;" v-for="(item, index) in list" :key="index">
                    <div class="box7"></div>
                    <div style="overflow: hidden; text-align: left; margin-top: 2%;">
                        <div class="qualifications_left_title" v-if="item.types === 1">身份证</div>
                        <div class="qualifications_left_title" v-if="item.types === 2">营业执照</div>
                        <div class="qualifications_left_title" v-if="item.types === 3">危险化学品经营许可证</div>
                        <div class="qualifications_left_title" v-if="item.types === 4">生产许可证</div>
                        <div v-show="!item.is_edit" class="qualifications_left_title" style="float: right; color: #333; width: 100px;">
                            <a-icon :type="item.show ? 'up' : 'down'" style="float: right; margin-top: 2%;" />
                            <span style="float: right; margin-right: 2%;cursor: pointer;" @click="item.show = !item.show">{{ item.show ? '收起' : '展开' }}</span>
                        </div>
                    </div>
                    <div v-show="item.is_edit">
                        <div style="overflow: hidden;">
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt">证书名称：</div>
                                <!-- <a-input style="width: 300px; float: left; margin-left: 10px;" v-model="item.name" placeholder="请输入" /> -->
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{ item.name }}</span>
                            </div>
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt" v-if="item.types === 3">经营单位名称：</div>
                                <div class="qualifications_item_txt" v-if="item.types === 4">企业名称：</div>
                                <div style="margin-left:200px;margin-top:6px">{{ qiyexinxi || '' }}</div>
                            </div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%;">
                            <div style="float: left;width: 50%; margin-top: 2%;" v-if="item.types === 3">
                                <div class="qualifications_item_txt">企业法定代表人：</div>
                                <a-input style="width: 300px; float: left; margin-left: 10px;" v-model="item.legalRepresentative" placeholder="请输入" />
                            </div>
                            <div style="float: left;width: 50%; margin-top: 2%;" v-if="item.types === 4">
                                <div class="qualifications_item_txt">证件编号：</div>
                                <a-input style="width: 300px; float: left; margin-left: 10px;" v-model="item.number" placeholder="请输入" />
                            </div>
                            <div style="float: left;width: 50%; margin-top: 2%;" @click.capture="list_index = index">
                                <div class="qualifications_item_txt">证书有效期：</div>
                                <!-- <a-range-picker style="width: 300px; float: left; margin-left: 10px;" :defaultValue="[item.startTime, item.endTime]" @change="pickerDate" /> -->
                                <a-date-picker v-model="item.startTime" placeholder="请选择" value-format="YYYY-MM-DD" style="float: left;width: 125px; margin-left: 20px; " />
                                <a-date-picker v-model="item.endTime" :showToday="false" value-format="YYYY-MM-DD" placeholder="请选择" style="float: left;width: 125px; margin-left: 20px;"></a-date-picker>
                            </div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%;" v-if="item.types === 3">
                            <div style="float: left;width: 50%; margin-top: 2%;" @click.capture="list_index = index">
                                <div class="qualifications_item_txt">登记编号：</div>
                                <a-input style="width: 300px; float: left; margin-left: 10px;" v-model="item.registerNumber" placeholder="请输入" />
                            </div>
                        </div>

                        <div style="overflow: hidden; margin-top: 4%;">
                            <div class="qualifications_item_txt" style="width: 10%; float: left; margin-left: 7%; padding-right: 2%;margin-bottom:20px">证书扫描件</div>
                            <ImgUpload ref="upload" :idList="count(item.scanList)" />
                            <!-- <div style="overflow: hidden; float: left;" v-if="(yingcang = true)" @click="chooseScan(index, 0)">
                                <a-upload action="/api/file/upload" :before-upload="beforeAvatarUpload" :showUploadList="false" list-type="picture-card" @change="uploadScan">
                                    <img v-if="item.scanList[0]" :src="'/api/file/preview/' + item.scanList[0]" alt="" class="scan" />
                                    <div v-else>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text" v-if="item.types === 3">危险化学品经营许可证正本</div>
                                        <div class="ant-upload-text" v-if="item.types === 4">生产许可证正本</div>
                                    </div>
                                </a-upload>
                                <div style="margin-left:34px" class="del" v-if="item.scanList[0]" @click="delImg(index, 0, item)">删除</div>
                            </div>
                            <div style="overflow: hidden; float: left;" @click="chooseScan(index, 1)">
                                <a-upload action="/api/file/upload" :before-upload="beforeAvatarUpload" :showUploadList="false" list-type="picture-card" @change="uploadScan">
                                    <img v-if="item.scanList[1]" :src="'/api/file/preview/' + item.scanList[1]" alt="" class="scan" />
                                    <div v-else>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text" v-if="item.types === 3">危险化学品经营明细</div>
                                        <div class="ant-upload-text" v-if="item.types === 4">生产许可证名称</div>
                                    </div>
                                </a-upload>
                                <div style="margin-left:34px" class="del" v-show="item.scanList[1]" @click="delImg(index, 1, item)">删除</div>
                            </div>
                            <div style="overflow: hidden; float: left;" @click="chooseScan(index, 2)">
                                <a-upload action="/api/file/upload" :before-upload="beforeAvatarUpload" :showUploadList="false" list-type="picture-card" @change="uploadScan">
                                    <img v-if="item.scanList[2]" :src="'/api/file/preview/' + item.scanList[2]" alt="" class="scan" />
                                    <div v-else>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">上传扫描件</div>
                                    </div>
                                </a-upload>
                                <div style="margin-left:34px" class="del" v-show="item.scanList[2]" @click="delImg(index, 2, item)">删除</div>
                            </div>
                            <div style="overflow: hidden; float: left;" @click="chooseScan(index, 3)">
                                <a-upload action="/api/file/upload" :before-upload="beforeAvatarUpload" :showUploadList="false" list-type="picture-card" @change="uploadScan">
                                    <img v-if="item.scanList[3]" :src="'/api/file/preview/' + item.scanList[3]" alt="" class="scan" />
                                    <div v-else>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">上传扫描件</div>
                                    </div>
                                </a-upload>
                                <div style="margin-left:34px" class="del" v-show="item.scanList[3]" @click="delImg(index, 3, item)">删除</div>
                            </div>
                            <div style="overflow: hidden; float: left;" @click="chooseScan(index, 4)">
                                <a-upload action="/api/file/upload" :before-upload="beforeAvatarUpload" :showUploadList="false" list-type="picture-card" @change="uploadScan">
                                    <img v-if="item.scanList[4]" :src="'/api/file/preview/' + item.scanList[4]" alt="" class="scan" />
                                    <div v-else>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">上传扫描件</div>
                                    </div>
                                </a-upload>
                                <div style="margin-left:34px" class="del" v-show="item.scanList[4]" @click="delImg(index, 4, item)">删除</div>
                            </div> -->
                        </div>

                        <div style="overflow: hidden;">
                            <div style="float: left;width: 100%; margin-top: 2%;">
                                <span style="float: left;margin-top: 5px;text-align: right; width: 15%">清单模板：</span>
                                <div style="margin-top: 5px;">
                                    <a :href="'/api/cdkelong_mall/user_certificate/public/licensedProductDownloadTemplate'" style="width: 84px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;margin-right:20px"> <img src="../assets/caigou/xiaicon.png" alt="" style="margin-left: 10px" /> 点击下载模板</a>
                                    <span style="width: 182px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 16px;">下载模板，请填写完成后上传</span>
                                </div>
                            </div>
                            <div style="float: left;width: 100%; margin-top: 2%;">
                                <span style="float: left;margin-top: 5px;text-align: right; width: 15%">资质清单：</span>
                                <div style="margin-top: 5px; margin-left: 15%">
                                    <a-upload name="file" :file-list="item.fileList" :multiple="true" action="/api/file/upload" @change="info => handleChange(info, item)" accept=".word,.excel,.docx,.doc,.xlsx,.xls">
                                        <a style="width: 84px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;margin-right:40px"> <img src="../assets/caigou/shang1.png" alt="" style="margin-left: 10px" /> 上传资质清单</a>
                                        <!--                            <span style="width: 182px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 16px;">填写完成后上传</span>-->
                                    </a-upload>
                                </div>
                            </div>
                        </div>
                        <div class="box14" style="float: right;margin-top: 70px;" @click="edit(item, index)">保存</div>
                    </div>
                    <div v-show="!item.is_edit && item.show">
                        <div style="overflow: hidden;">
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt">证书名称：</div>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{ item.name }}</span>
                            </div>
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt" v-if="item.types === 1">姓名：</div>
                                <div class="qualifications_item_txt" v-if="item.types === 2">企业全称：</div>
                                <div class="qualifications_item_txt" v-if="item.types === 3">经营单位名称：</div>
                                <div class="qualifications_item_txt" v-if="item.types === 4">企业名称：</div>
                                <div class="qualifications_item_txt" v-if="item.types === null">资质主体：</div>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.types === 1">{{ item.subjectName || '' }}</span>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.types === 2">{{ qiyexinxi || '' }}</span>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.types === 3">{{ qiyexinxi || '' }}</span>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.types === 4">{{ qiyexinxi || '' }}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%;">
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt" v-if="item.types == 1">身份证号码：</div>
                                <div class="qualifications_item_txt" v-if="item.types == 2">统一社会信用代码：</div>
                                <div class="qualifications_item_txt" v-if="item.types == 3">登记编号：</div>
                                <div class="qualifications_item_txt" v-if="item.types == 4">证件编号：</div>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.types !== 3">{{ item.number }}</span>
                                <span style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.types == 3">{{ item.registerNumber }}</span>
                            </div>
                            <div style="float: left;width: 50%; margin-top: 2%;" @click.capture="list_index = index">
                                <div class="qualifications_item_txt">证书有效期：</div>
                                <span v-if="item.endTime != null" style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{ item.startTime }}-{{ item.endTime }}</span>
                                <span v-else style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{ item.startTime }}-长期有效</span>
                            </div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%;" v-if="item.types === 1">
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt">性别：</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.gender == 0">未知</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.gender == 1">男</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px" v-if="item.gender == 2">女</div>
                            </div>
                            <div style="float: left;width: 50%; margin-top: 2%;" @click.capture="list_index = index" v-if="item.types === 1">
                                <div class="qualifications_item_txt">用户类型：</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px;" v-if="item.userClassName == ''">个人用户</div>
                                <div class="left_txt" style="twidth: 300px; float: left; margin-left: 10px;margin-top:6px;" v-if="item.userClassName !== ''">企业用户-{{ item.userClassName }}</div>
                            </div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%;" v-if="item.types === 2">
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt">法定代表人：</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{ item.legalRepresentative }}</div>
                            </div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%;" v-if="item.types === 3">
                            <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt">企业法定代表人：</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{ item.legalRepresentative }}</div>
                            </div>
                            <!-- <div style="float: left;width: 50%; margin-top: 2%;">
                                <div class="qualifications_item_txt" >登记编号：</div>
                                <div class="left_txt" style="width: 300px; float: left; margin-left: 10px;margin-top:6px">{{item.registerNumber}}</div>
                            </div> -->
                        </div>
                        <div style="overflow: hidden; margin-top: 4%;" v-if="item.scanList !== ''">
                            <div class="qualifications_item_txt" style="width: 10%; float: left; margin-left: 7%; padding-right: 2%;" v-if="item.types === 1">身份证件：</div>
                            <div class="qualifications_item_txt" style="width: 10%; float: left; margin-left: 7%; padding-right: 2%;" v-if="item.types === 2">营业执照：</div>
                            <div class="qualifications_item_txt" style="width: 13%; float: left; margin-left: 5%; padding-right: 3%;" v-if="item.types === 3">证书扫描件：</div>
                            <div class="qualifications_item_txt" style="width: 13%; float: left; margin-left: 5%; padding-right: 3%;" v-if="item.types === 4">证书扫描件：</div>
                            <div v-for="(img, index) in item.scanList" :key="index" style="overflow: hidden; float: left;">
                                <a :href="'/api/file/preview/' + img" target="_blank">
                                    <img v-if="img" :src="'/api/file/preview/' + img" class="scan" alt="" style="margin-left:5px;" />
                                </a>
                            </div>
                        </div>
                        <div style="float: left;width: 100%; margin-top: 2%;">
                            <span style="float: left;margin-top: 13px;text-align: right; width: 15%" v-if="item.types != 2 && item.types != 1">资质清单：</span>
                            <div style="margin-top: 5px; margin-left: 15%; margin-right: 160px">
                                <a-upload name="file" :file-list="item.fileList" :multiple="true" action="/api/file/upload" :showUploadList="{ showPreviewIcon: false, showRemoveIcon: false }" @change="info => handleChange(info, item)" accept=".word,.excel,.docx,.doc,.xlsx,.xls"> </a-upload>
                            </div>
                        </div>
                        <div class="box14" style="float: right;margin-top: -45px;" v-if="item.types != 2 && item.types != 1" @click="item.is_edit = true">修改</div>
                        <!-- <div style="overflow: hidden; margin: 4% 0 0 16%;">
                            <a-space direction="vertical" style="width:100%">
                              <p v-if="list[index].availableAll === true" style="margin-left:200px">已授权所有危化品</p>
                                <a-space v-else size="middle">
                                    <a-button type="link" @click="showAuthorized(index)">
                                        <a-space>
                                            查看全部已经授权商品<a-icon type="down" />
                                        </a-space>
                                    </a-button>
                                    <a-input-search defaultValue="" @change="list_index=index" @search="searchAuthorized" placeholder="请输入名称、CAS号" />
                                </a-space>
                                <table class="table-authorized" v-show="item.show_list_authorized">
                                    <tr>
                                        <td>产品名称</td>
                                        <td>CAS号</td>
                                        <td>
                                            <span @click="turnPage(-1)"><</span>
                                            <span @click="turnPage(1)">></span>
                                        </td>
                                    </tr>
                                    <tr v-for="(i,index_i) in item.list_authorized" :key="`authorized${index_i}`">
                                        <td>{{i.chemistryName}}</td>
                                        <td>{{i.casNum}}</td>
                                        <td></td>
                                    </tr>
                                    <tr v-show="!item.list_authorized.length">
                                        <td colspan="3" style="text-align: center;">暂无授权商品</td>
                                    </tr>
                                </table>
                            </a-space>
                        </div> -->
                    </div>
                </div>

                <div v-if="list.length == 0" style="margin-top: 40px; text-align: center;">没有记录~</div>
            </div>
        </div>
        <foot />

        <a-modal :visible="visible" :footer="null" :width="880" :height="300" @cancel="hideModal">
            <div class="pop_title">新增资质</div>
            <div style="overflow: hidden; width: 98%; margin: 20px auto">
                <div style="overflow: hidden; margin-top: 20px;">
                    <div class="add_zizhi_txt">证书名称</div>
                    <a-input v-model="add_obj.name" style="width: 300px; float: left; margin-left: 10px;" placeholder="请输入" />
                </div>
                <div style="overflow: hidden; margin-top: 20px;">
                    <div class="add_zizhi_txt">资质证书编号</div>
                    <a-input v-model="add_obj.number" style="width: 300px; float: left; margin-left: 10px;" placeholder="请输入" />
                </div>
                <div style="overflow: hidden; margin-top: 20px;">
                    <div class="add_zizhi_txt">资质主体</div>
                    <div style="margin-left:200px;margin-top:6px">
                        <strong>{{ qiyexinxi || '' }}</strong>
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 20px;">
                    <div class="add_zizhi_txt">证书有效期</div>
                    <a-range-picker style="width: 300px; float: left; margin-left: 10px;" @change="add_time_onChange" />
                </div>

                <div style="overflow: hidden; margin-top: 20px;">
                    <div class="add_zizhi_txt">证书扫描件</div>
                    <div style="overflow: hidden; float: left; margin-left: 10px;">
                        <a-upload name="file" list-type="picture-card" class="avatar-uploader" :before-upload="beforeAvatarUpload" :show-upload-list="false" action="/api/file/upload" @change="add_uploader1">
                            <img v-if="scan1" :src="'/api/file/preview/' + scan1" alt="" class="scan" />
                            <div v-else>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    上传扫描件
                                </div>
                            </div>
                        </a-upload>
                    </div>
                    <div style="overflow: hidden; float: left; margin-left: 10px;">
                        <a-upload name="file" list-type="picture-card" class="avatar-uploader" :before-upload="beforeAvatarUpload" :show-upload-list="false" action="/api/file/upload" @change="add_uploader2">
                            <img v-if="scan2" :src="'/api/file/preview/' + scan2" alt="" class="scan" />
                            <div v-else>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    上传扫描件
                                </div>
                            </div>
                        </a-upload>
                    </div>
                    <div style="overflow: hidden; float: left; margin-left: 10px;">
                        <a-upload name="file" list-type="picture-card" class="avatar-uploader" :before-upload="beforeAvatarUpload" :show-upload-list="false" action="/api/file/upload" @change="add_uploader3">
                            <img v-if="scan3" :src="'/api/file/preview/' + scan3" alt="" class="scan" />
                            <div v-else>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    上传扫描件
                                </div>
                            </div>
                        </a-upload>
                    </div>
                    <div style="overflow: hidden; float: left; margin-left: 10px;">
                        <a-upload name="file" list-type="picture-card" class="avatar-uploader" :before-upload="beforeAvatarUpload" :show-upload-list="false" action="/api/file/upload" @change="add_uploader4">
                            <img v-if="scan4" :src="'/api/file/preview/' + scan4" alt="" class="scan" />
                            <div v-else>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    上传扫描件
                                </div>
                            </div>
                        </a-upload>
                    </div>
                    <div style="overflow: hidden; float: left; margin-left: 10px;">
                        <a-upload name="file" list-type="picture-card" class="avatar-uploader" :before-upload="beforeAvatarUpload" :show-upload-list="false" action="/api/file/upload" @change="add_uploader5">
                            <img v-if="scan5" :src="'/api/file/preview/' + scan5" alt="" class="scan" />
                            <div v-else>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    上传扫描件
                                </div>
                            </div>
                        </a-upload>
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 20px;">
                    <span class="add_zizhi_txt">清单模板</span>
                    <div style="margin-top: 5px;">
                        <a :href="'/api/cdkelong_mall/user_certificate/public/licensedProductDownloadTemplate'" style="width: 84px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;margin-right:20px"> <img src="../assets/caigou/xiaicon.png" alt="" style="margin-left: 10px" /> 点击下载模板</a>
                        <span style="width: 182px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 16px;">下载模板，请填写完成后上传</span>
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 20px;">
                    <span class="add_zizhi_txt">资质清单</span>
                    <div style="margin-top: 5px; margin-left: 20%">
                        <a-upload name="file" :file-list="add_obj.fileList" :multiple="true" action="/api/file/upload" @change="info => handleChange(info, add_obj)" accept=".word,.excel,.docx,.doc,.xlsx,.xls">
                            <a style="width: 84px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;margin-right:40px"> <img src="../assets/caigou/shang1.png" alt="" style="margin-left: 10px" /> 上传资质清单</a>
                        </a-upload>
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 20px;">
                    <div class="add_zizhi_txt"></div>
                    <div class="box14" @click="add_tijiao" style="float: left; margin-left: 10px;">提交</div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import moment from 'moment';
import ImgUpload from '../components/ImgUploadNoe/ImgUpload.vue';
export default {
    name: 'Qualification',
    components: {
        userLeft,
        htmlHeader,
        foot,
        ImgUpload
    },
    data() {
        return {
            fileList: [],
            attachment: '',
            yingcang: true,
            isshow: false,
            visible: false,
            list: [],
            isImage: null,
            list_index: null,
            list_scan_index: null,
            scan1: '',
            scan2: '',
            scan3: '',
            scan4: '',
            scan5: '',
            add_obj: {
                createdBy: '', //创建人id
                createdByInfo: {}, //创建人信息
                information: '', //附加信息
                issuingAuthority: '', //颁发机构
                remarks: '', //备注

                endTime: '', //结束时间
                name: '', //证书名称
                number: '', //证书号码
                scan: [], //扫描件
                startTime: '', //证书有效期开始时间
                subjectName: '', //主体全称,
                licensedProductFileId: '',
                fileList: []
            },
            list_authorized: [],
            qiyexinxi: {}
        };
    },
    created() {
        this.getList();
        this.api.get_companyFullName().then(res => {
            this.qiyexinxi = res.data;
            this.add_obj.subjectName = res.data;
        });
        this.api.jiachashiming().then(res => {
            if (res.data.realName === false) {
                this.$message.error('即将跳转个人信息完成内容填写');
                setTimeout(() => {
                    this.$router.push('/user_info');
                }, 1000);
            } else if (res.data.company === false) {
                this.$message.error('即将跳转企业信息完成内容填写');
                setTimeout(() => {
                    this.$router.push('/enterprise_info');
                }, 1000);
            }
        });
    },
    beforeCreate() {
        setTimeout(() => {
            this.setTime();
        }, 2000);
    },
    methods: {
        count: function(arr) {
            let newArr = [];
            for (let i = 0; i < arr.length; i++) {
                let obj = {
                    uid: i,
                    id: arr[i]
                };
                newArr.push(obj);
            }
            return newArr;
        },
        beforeAvatarUpload(file) {
            let types = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp'];
            this.isImage = types.includes(file.type);
            console.log('file', this.isImage);
            if (!this.isImage) {
                this.$message.error('上传图片只能是 JPG、JPEG、PNG、bmp 格式!');
            }
        },
        showAuthorized(index) {
            const item = this.list[index];
            this.list_index = index;

            if (item.show_list_authorized) {
                item.show_list_authorized = false;
            } else {
                item.show_list_authorized = true;
                item.page = 0;
                item.search = '';
                this.getAuthorized();
            }
        },
        // 翻页
        turnPage(flag) {
            const item = this.list[this.list_index];
            item.page += flag;
            this.getAuthorized();
        },
        // 查询授权的商品
        getAuthorized() {
            const item = this.list[this.list_index];
            this.api
                .get_authorized_list({
                    certificateId: item.uuid,
                    search: item.search,
                    size: 2,
                    page: item.page
                })
                .then(res => {
                    if (res.data) {
                        item.list_authorized = res.data.content || [];
                    }
                });
        },
        // 搜索授权的商品
        searchAuthorized(search) {
            if (!search) return;
            const item = this.list[this.list_index];
            item.show_list_authorized = true;
            item.page = 0;
            item.search = search;
            this.getAuthorized(search);
        },
        uploadScan(e) {
            console.log(e);
            if (e.file.status === 'done') {
                const item = this.list[this.list_index];
                const scan = item.scanList;
                const id = e.file.response.data.uuid;
                scan.splice(this.list_scan_index, 1, id);
            }
        },
        chooseScan(index1, index2) {
            console.log(index1, index2);
            this.list_index = index1;
            this.list_scan_index = index2;
        },
        delImg(index1, index2, item) {
            console.log(item.scanList);
            item.scanList.splice(index2, 1);
            this.yingcang = false;
        },
        // 显示弹窗
        showModal() {
            var that = this;
            var islogin = localStorage.getItem('Access-Token');
            if (islogin) {
                this.visible = true;
            }
        },
        hideModal() {
            this.visible = false;
        },
        _authorizedTableSearch(e, item) {
            this._getAuthorizedListFun({ search: e.data, item: item });
        },
        _authorizedTableChange(pagination, item) {
            this._getAuthorizedListFun({ page: pagination.current, item: item });
        },
        // 获取授权商品列表
        _getAuthorizedListFun({ item, search = '', page = 0 }) {
            this.api
                .get_authorized_list({
                    certificateId: item.uuid,
                    search,
                    page,
                    size: 3
                })
                .then(res => {
                    if (res.data) {
                        this.list_authorized = res.data.content || [];
                    }
                });
        },
        // 获取当前时间和过期时间比较
        setTime() {
            let arr = this.list;
            for (let i = 0; i < arr.length; i++) {
                var guoqi = moment(arr[i].endTime).unix() * 1000; //过期时间
                var dateTime = moment(new Date()).unix() * 1000; // 当前时间
                var time = guoqi - 3600 * 1000 * 24 * 90; //当前时间-90
                // console.log('过期：',guoqi);
                // console.log('过期-90天：' ,dateTime.getTime());
                // console.log('当前时间',time.getTime());
                if (arr[i].endTime == null) {
                } else if (dateTime < time) {
                    console.log('没过期');
                } else if (time < dateTime && dateTime < guoqi) {
                    console.log('快过期');
                    this.$message.warning(`您的${arr[i].name}即将过期，请您尽快去换证，并更新上传资质证照`);
                } else {
                    console.log('过期');
                    this.$message.error(`您的${arr[i].name}已过期，请您尽快去换证，并更新上传资质证照`);
                }
            }
        },
        // 选择器
        pickerDate(e) {
            const item = this.list[this.list_index];
            item.startTime = this.format(Date.parse(e[0]._d));
            item.endTime = this.format(Date.parse(e[1]._d));
        },
        // 上传文件
        uploadFile(e, item) {
            e.fileList.forEach(file => {
                if (file.status === 'done') {
                    let uuid = file.response.data ? file.response.data.uuid : null;
                    if (!item.scanList.find(id => id === uuid)) {
                        item.scanList.push(uuid);
                    }
                }
            });
        },
        // 查询列表
        getList() {
            this.api.get_user_certificate().then(res => {
                console.log(res.data, 111);
                if (!res.data) return;
                res.data.forEach(item => {
                    item.show = true;
                    item.show_list_authorized = false;
                    item.is_edit = false;
                    item.list_authorized = [];
                    item.fileList = item.licensedProductFileId
                        ? [
                              {
                                  uid: item.licensedProductFileId,
                                  status: 'done',
                                  url: `/api/file/preview/${item.licensedProductFileId}`,
                                  name: '资质清单.xlsx'
                              }
                          ]
                        : [];
                });
                this.list = res.data;
                // console.log(JSON.stringify(res.data), 9999)
                // this.setTime()
            });
        },
        //上传
        handleChange(info, item) {
            let fileList = [...info.fileList];
            item.fileList = fileList.slice(-1).map(file => {
                if (file.response) {
                    file.url = `/api/file/preview/${file.response.data.uuid}`;
                }
                return file;
            });

            if (info.file.status === 'done') {
                this.$message.success('上传成功');
                item.licensedProductFileId = info.file.response.data.uuid;
            } else if (info.file.status === 'error') {
                this.$message.error('上传失败，请重新上传');
                info.fileList.pop();
            }
        },
        // 编辑
        edit(item, index) {
            if (this.isImage == false) {
                this.$message.error('图片格式不正确');
                return;
            }
            this.isshow = true;
            item.subjectName = this.qiyexinxi;
            console.log(item.scanList, '=======');
            const img = this.$refs['upload'][index].list;
            let imgarry = [];
            img.forEach(item => {
                if(item.id){
                    imgarry.push(item.id);
                }
            });
            console.log(this.$refs['upload'][index].list, '=======111111');
            // item.scanList = item.scanList.filter(i => i);
            item.scanList = imgarry;
            this.api.edit_user_certificate(item).then(res => {
                if (res.ok) {
                    this.$message.success(res.message);
                    this.getList();
                    this.isshow = false;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 提交新增
        add_tijiao() {
            // this.add_obj.startTime == '' ||this.add_obj.endTime == '' ||
            if (this.add_obj.name == '' || this.add_obj.number == '' || this.add_obj.subjectName == '' || this.isImage == false) {
                this.$message.error('请填写完整或者检查图片类型');
                return;
            }

            const scans = [];
            if (this.scan1) scans.push(this.scan1);
            if (this.scan2) scans.push(this.scan2);
            if (this.scan3) scans.push(this.scan3);
            if (this.scan4) scans.push(this.scan4);
            if (this.scan5) scans.push(this.scan5);
            if (!scans.length) return this.$message.error('请上传图片');
            this.add_obj.scanList = scans;
            this.api.add_user_certificate(this.add_obj).then(res => {
                if (res.ok) {
                    this.$message.success(res.message);
                    this.visible = false;
                    this.getList();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 新增上传
        add_uploader1(e) {
            if (e.file.status === 'done') {
                this.scan1 = e.file.response.data.uuid;
            }
        },
        add_uploader2(e) {
            if (e.file.status === 'done') {
                this.scan2 = e.file.response.data.uuid;
            }
        },
        add_uploader3(e) {
            if (e.file.status === 'done') {
                this.scan3 = e.file.response.data.uuid;
            }
        },
        add_uploader4(e) {
            if (e.file.status === 'done') {
                this.scan4 = e.file.response.data.uuid;
            }
        },
        add_uploader5(e) {
            if (e.file.status === 'done') {
                this.scan5 = e.file.response.data.uuid;
            }
        },
        // 新增弹框的时间选择
        add_time_onChange(e) {
            this.add_obj.endTime = this.format(Date.parse(e[1]._d));
            this.add_obj.startTime = this.format(Date.parse(e[0]._d));
        },
        // 时间戳转日期
        format(e) {
            var time = new Date(e);
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            var d = time.getDate();
            return y + '-' + this.add(m) + '-' + this.add(d);
        },
        add(m) {
            return m < 10 ? '0' + m : m;
        }
    }
};
</script>

<style scoped>
.del {
    cursor: pointer;
}
.del:hover {
    color: #2255e0;
}
.table-authorized {
    width: 100%;
}
.table-authorized > tr {
    text-indent: 20px;
    line-height: 40px;
    border-bottom: 1px dashed #e8e6e6;
}
.table-authorized > tr:first-child {
    background: #f4f4f4;
    border: none;
}
tr > td:last-child {
    text-align: center;
}
td > span {
    padding: 10px;
    color: #2b9a34;
    cursor: pointer;
}

.ant-upload {
    width: 50px !important;
}

.add_zizhi_txt {
    width: 20%;
    text-align: right;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-top: 5px;
}

.ant-select-selection--single {
    border: none !important;
}

.qualifications_item_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-top: 5px;
    text-align: right;
    width: 30%;
}

.qualifications_left_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    float: left;
}

.qualifications_con {
    width: 100%;
    height: 400px;
    background: pink;
}

.box14 {
    width: 120px;
    height: 32px;
    border: 1px solid #2c9a34;
    float: right;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    cursor: pointer;
}

.box13 {
    width: 16.6666%;
    height: 100%;
    float: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}

.box12 {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
    margin-top: 4%;
}

.box11 {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    margin: 8% auto;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
}

.box10 {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ff9629;
    /* line-height: 16px; */
    margin: 4% auto;
}

.box9 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin: auto;
}

.box8 {
    width: 100%;
    height: 105px;
    background: EEF7EF;
    /* opacity: 0.08; */
    padding-top: 4%;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 990px;
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
img.scan {
    width: 85px;
    height: 85px;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/qualifications.vue